// !ORDER MATTERS
export const METHODS = {
  CREDITS: "credits",
  ZOOZ: "zooz",
  PAYU: "payu",
  VOLT: "volt",
  APPLE_PAY: "apple_pay",
  PIX: "pix",
  PROMOCODE: "promocode",
  REVOLUT_PAY: "revolut_pay",
  CUP: "cup",
  TRUSTLY: "trustly",
  SOFORT: "sofort",
  ALIPAY: "alipay",
  PAYPAL: "paypal",
  BANK_ACCOUNT: "bank_account",
} as const

export type Method = typeof METHODS[keyof typeof METHODS]

// all available types from https://booking-api.skypicker.com/mmb/v1/ui/#/refunds/kw.mambo.handlers.refund_offers.get
export const REFUND_OFFER_TYPE = {
  OUT_OF_POCKET: "out_of_pocket",
  CREDITS_INCENTIVISATION: "credits_incentivisation",
  ALTERNATIVE_METHOD: "alternative_method",
  TECHNICAL_ISSUE: "technical_issue",
  PROACTIVE_REFUND: "proactive_refund",
  CUSTOMER_VOLUNTARY_CANCEL_BEFORE_BOOKING_CONFIRMATION:
    "customer_voluntary_cancel_before_booking_confirmation",
  // SOLD_OUT = "sold_out", // TODO MMB-3900
} as const

export type RefundOfferType = typeof REFUND_OFFER_TYPE[keyof typeof REFUND_OFFER_TYPE]

export type RefundOffer = {
  id: number
  type: RefundOfferType
}

export type RefundOffers = RefundOffer[]
